import { Link } from "react-router-dom";

export const BrandMark = ({ size = "md", inverted = false }) => {
  const sizes = {
    sm: { a: "text-2xl", name: "text-[10px]", sub: "text-[8px]" },
    md: { a: "text-4xl", name: "text-[11px]", sub: "text-[9px]" },
    lg: { a: "text-6xl", name: "text-sm", sub: "text-[11px]" },
  };
  const s = sizes[size];

  return (
    <Link to="/" data-testid="brand-logo" className="flex items-center gap-3 group">
      <span
        className={`${s.a} font-serif italic leading-none gold-text drop-shadow-[0_0_8px_rgba(255,215,0,0.35)] group-hover:drop-shadow-[0_0_16px_rgba(255,215,0,0.6)] transition-all duration-500`}
        style={{ fontStyle: "italic" }}
      >
        A
      </span>
      <span className="flex flex-col leading-tight">
        <span
          className={`${s.name} tracking-[0.32em] uppercase font-medium ${
            inverted ? "text-beige" : "text-ink"
          }`}
        >
          Tamara Alves
        </span>
        <span
          className={`${s.sub} tracking-[0.4em] uppercase ${
            inverted ? "text-gold" : "text-gold"
          }`}
        >
          Hairstylist
        </span>
      </span>
    </Link>
  );
};

export default BrandMark;
